var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	28217: () => (loadStrictVersion("default", "react", true, [1,18,2,0], () => (() => (__webpack_require__(65043))))),
	7217: () => (loadStrictVersion("default", "react-dom", true, [1,18,2,0], () => (() => (__webpack_require__(97950))))),
	68316: () => (loadStrictVersion("default", "@progress/kendo-react-common", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(4791), __webpack_require__.e(6990)]).then(() => (() => (__webpack_require__(24791))))))),
	406: () => (loadStrictVersion("default", "@progress/kendo-svg-icons", false, [1,4,0,0], () => (__webpack_require__.e(7112).then(() => (() => (__webpack_require__(17112))))))),
	12304: () => (loadStrictVersion("default", "@progress/kendo-react-intl", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(3602), __webpack_require__.e(6733)]).then(() => (() => (__webpack_require__(43602))))))),
	48006: () => (loadStrictVersion("default", "@progress/kendo-react-popup", false, [1,10,1,0], () => (__webpack_require__.e(9557).then(() => (() => (__webpack_require__(71938))))))),
	58634: () => (loadStrictVersion("default", "@progress/kendo-react-layout", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(1315), __webpack_require__.e(9710), __webpack_require__.e(8660)]).then(() => (() => (__webpack_require__(41315))))))),
	23524: () => (loadStrictVersion("default", "@progress/kendo-react-inputs", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(5276), __webpack_require__.e(8634), __webpack_require__.e(8868), __webpack_require__.e(418)]).then(() => (() => (__webpack_require__(95276))))))),
	46733: () => (loadStrictVersion("default", "@progress/kendo-intl", false, [1,3,1,1], () => (__webpack_require__.e(3589).then(() => (() => (__webpack_require__(83589))))))),
	41574: () => (loadStrictVersion("default", "@progress/kendo-react-dropdowns", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(9686), __webpack_require__.e(8634), __webpack_require__.e(252)]).then(() => (() => (__webpack_require__(79686))))))),
	50418: () => (loadStrictVersion("default", "@progress/kendo-react-dialogs", false, [1,10,1,0], () => (__webpack_require__.e(560).then(() => (() => (__webpack_require__(68179))))))),
	15286: () => (loadStrictVersion("default", "@progress/kendo-data-query", false, [1,1,7,0], () => (__webpack_require__.e(9298).then(() => (() => (__webpack_require__(9298))))))),
	64860: () => (loadStrictVersion("default", "@progress/kendo-react-dateinputs", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(7042), __webpack_require__.e(8634), __webpack_require__.e(6733)]).then(() => (() => (__webpack_require__(27042))))))),
	39651: () => (loadStrictVersion("default", "classnames", false, [1,2,3,1], () => (__webpack_require__.e(8139).then(() => (() => (__webpack_require__(98139))))))),
	252: () => (loadStrictVersion("default", "@progress/kendo-react-treeview", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(4573), __webpack_require__.e(9710)]).then(() => (() => (__webpack_require__(94573))))))),
	46738: () => (loadStrictVersion("default", "@progress/kendo-react-data-tools", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(8684), __webpack_require__.e(9710)]).then(() => (() => (__webpack_require__(78684))))))),
	47882: () => (loadStrictVersion("default", "@progress/kendo-react-indicators", false, [1,10,1,0], () => (__webpack_require__.e(5317).then(() => (() => (__webpack_require__(17698))))))),
	67090: () => (loadStrictVersion("default", "@progress/kendo-react-form", false, [1,10,1,0], () => (__webpack_require__.e(4361).then(() => (() => (__webpack_require__(76742))))))),
	1488: () => (loadStrictVersion("default", "@progress/kendo-react-notification", false, [1,10,1,0], () => (__webpack_require__.e(3393).then(() => (() => (__webpack_require__(35774))))))),
	2674: () => (loadStrictVersion("default", "@microsoft/applicationinsights-web", false, [1,3,0,7], () => (Promise.all([__webpack_require__.e(9270), __webpack_require__.e(4330)]).then(() => (() => (__webpack_require__(44330))))))),
	3122: () => (loadStrictVersion("default", "@progress/kendo-react-listbox", false, [1,10,1,0], () => (__webpack_require__.e(5884).then(() => (() => (__webpack_require__(93503))))))),
	4220: () => (loadStrictVersion("default", "react-device-detect", false, [1,2,2,3], () => (__webpack_require__.e(8738).then(() => (() => (__webpack_require__(8738))))))),
	5639: () => (loadStrictVersion("default", "react-toastify", false, [1,9,1,2], () => (__webpack_require__.e(4526).then(() => (() => (__webpack_require__(42145))))))),
	9400: () => (loadStrictVersion("default", "@progress/kendo-react-listview", false, [1,10,1,0], () => (__webpack_require__.e(4704).then(() => (() => (__webpack_require__(44704))))))),
	11966: () => (loadStrictVersion("default", "@progress/kendo-react-scrollview", false, [1,10,1,0], () => (__webpack_require__.e(8636).then(() => (() => (__webpack_require__(96255))))))),
	12162: () => (loadStrictVersion("default", "@use-it/event-listener", false, [2,0,1,7], () => (__webpack_require__.e(5320).then(() => (() => (__webpack_require__(75320))))))),
	13350: () => (loadStrictVersion("default", "react-vertical-timeline-component", false, [1,3,5,3], () => (__webpack_require__.e(1739).then(() => (() => (__webpack_require__(24120))))))),
	15980: () => (loadStrictVersion("default", "@progress/kendo-react-charts", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(3919), __webpack_require__.e(5640)]).then(() => (() => (__webpack_require__(93919))))))),
	22438: () => (loadStrictVersion("default", "js-cookie", false, [1,3,0,5], () => (__webpack_require__.e(1880).then(() => (() => (__webpack_require__(1880))))))),
	27214: () => (loadStrictVersion("default", "@progress/kendo-react-tooltip", false, [1,10,1,0], () => (__webpack_require__.e(8122).then(() => (() => (__webpack_require__(75741))))))),
	27289: () => (loadStrictVersion("default", "react-timeago", false, [1,7,2,0], () => (__webpack_require__.e(2626).then(() => (() => (__webpack_require__(90245))))))),
	28459: () => (loadStrictVersion("default", "nanoid", false, [1,3,3,2], () => (__webpack_require__.e(3712).then(() => (() => (__webpack_require__(63712))))))),
	28639: () => (loadStrictVersion("default", "oidc-client-ts", false, [1,3,0,1], () => (__webpack_require__.e(248).then(() => (() => (__webpack_require__(90248))))))),
	29167: () => (loadStrictVersion("default", "react-router-dom", false, [1,6,3,0], () => (__webpack_require__.e(3245).then(() => (() => (__webpack_require__(53245))))))),
	30443: () => (loadStrictVersion("default", "@charkour/react-reactions", false, [2,0,11,0], () => (__webpack_require__.e(6262).then(() => (() => (__webpack_require__(46262))))))),
	31926: () => (loadStrictVersion("default", "@progress/kendo-react-grid", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(623), __webpack_require__.e(9710)]).then(() => (() => (__webpack_require__(70623))))))),
	35792: () => (loadStrictVersion("default", "@progress/kendo-react-editor", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(4969), __webpack_require__.e(86)]).then(() => (() => (__webpack_require__(54969))))))),
	37112: () => (loadStrictVersion("default", "react-helmet", false, [1,6,1,0], () => (__webpack_require__.e(3972).then(() => (() => (__webpack_require__(41591))))))),
	39033: () => (loadStrictVersion("default", "@reduxjs/toolkit", false, [1,1,9,3], () => (Promise.all([__webpack_require__.e(805), __webpack_require__.e(9815)]).then(() => (() => (__webpack_require__(19815))))))),
	39686: () => (loadStrictVersion("default", "@progress/kendo-react-sortable", false, [1,10,1,0], () => (__webpack_require__.e(7218).then(() => (() => (__webpack_require__(34837))))))),
	39966: () => (loadStrictVersion("default", "@progress/kendo-react-map", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(8786), __webpack_require__.e(5640)]).then(() => (() => (__webpack_require__(68786))))))),
	45007: () => (loadStrictVersion("default", "redux-dynamic-middlewares", false, [1,2,2,0], () => (Promise.all([__webpack_require__.e(805), __webpack_require__.e(1686)]).then(() => (() => (__webpack_require__(51686))))))),
	53512: () => (loadStrictVersion("default", "react-redux", true, [1,8,0,5], () => (() => (__webpack_require__(22166))))),
	56249: () => (loadStrictVersion("default", "react-markdown", false, [1,10,1,0], () => (__webpack_require__.e(3713).then(() => (() => (__webpack_require__(23713))))))),
	58444: () => (loadStrictVersion("default", "@microsoft/applicationinsights-react-js", false, [1,17,0,3], () => (Promise.all([__webpack_require__.e(9270), __webpack_require__.e(5376)]).then(() => (() => (__webpack_require__(72995))))))),
	61016: () => (loadStrictVersion("default", "@progress/kendo-react-upload", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(8171), __webpack_require__.e(8660)]).then(() => (() => (__webpack_require__(78171))))))),
	66775: () => (loadStrictVersion("default", "@fluentui/react-components", false, [1,9,56,2], () => (__webpack_require__.e(6837).then(() => (() => (__webpack_require__(6837))))))),
	68374: () => (loadStrictVersion("default", "use-debounce", false, [1,9,0,3], () => (__webpack_require__.e(2970).then(() => (() => (__webpack_require__(2970))))))),
	76441: () => (loadStrictVersion("default", "react-sortablejs", false, [1,6,1,4], () => (Promise.all([__webpack_require__.e(8389), __webpack_require__.e(3405)]).then(() => (() => (__webpack_require__(15786))))))),
	78385: () => (loadStrictVersion("default", "react-json-tree", false, [2,0,17,0], () => (__webpack_require__.e(1868).then(() => (() => (__webpack_require__(1868))))))),
	80040: () => (loadStrictVersion("default", "react-bootstrap", false, [1,2,10,6], () => (Promise.all([__webpack_require__.e(7549), __webpack_require__.e(4911)]).then(() => (() => (__webpack_require__(94911))))))),
	80918: () => (loadStrictVersion("default", "redux-oidc", false, [1,4,0,0,,"beta1"], () => (Promise.all([__webpack_require__.e(632), __webpack_require__.e(4198)]).then(() => (() => (__webpack_require__(41817))))))),
	87607: () => (loadStrictVersion("default", "javascript-time-ago", false, [1,2,5,9], () => (__webpack_require__.e(6246).then(() => (() => (__webpack_require__(16246))))))),
	93024: () => (loadStrictVersion("default", "ramda", false, [2,0,28,0], () => (__webpack_require__.e(631).then(() => (() => (__webpack_require__(30631))))))),
	93655: () => (loadStrictVersion("default", "@popperjs/core", false, [1,2,11,8], () => (Promise.all([__webpack_require__.e(7549), __webpack_require__.e(6573)]).then(() => (() => (__webpack_require__(86573))))))),
	96052: () => (loadStrictVersion("default", "react-custom-scrollbars-2", false, [1,4,5,0], () => (__webpack_require__.e(979).then(() => (() => (__webpack_require__(43360))))))),
	58868: () => (loadStrictVersion("default", "@progress/kendo-drawing", false, [1,1,21,2], () => (__webpack_require__.e(4660).then(() => (() => (__webpack_require__(34660))))))),
	25640: () => (loadStrictVersion("default", "@progress/kendo-charts", false, [1,2,7,1], () => (Promise.all([__webpack_require__.e(2884), __webpack_require__.e(8868)]).then(() => (() => (__webpack_require__(78122))))))),
	96990: () => (loadStrictVersion("default", "@progress/kendo-licensing", false, [1,1,6,0], () => (__webpack_require__.e(1517).then(() => (() => (__webpack_require__(21517))))))),
	89710: () => (loadStrictVersion("default", "@progress/kendo-react-animation", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(7868), __webpack_require__.e(1151)]).then(() => (() => (__webpack_require__(51151))))))),
	50086: () => (loadStrictVersion("default", "@progress/kendo-react-pdf", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(9872), __webpack_require__.e(8868)]).then(() => (() => (__webpack_require__(49872))))))),
	28660: () => (loadStrictVersion("default", "@progress/kendo-react-progressbars", false, [1,10,1,0], () => (Promise.all([__webpack_require__.e(9710), __webpack_require__.e(4679)]).then(() => (() => (__webpack_require__(77060))))))),
	11786: () => (loadStrictVersion("default", "classnames", false, [1,2,3,1], () => (__webpack_require__.e(1833).then(() => (() => (__webpack_require__(71833))))))),
	73766: () => (loadStrictVersion("default", "sortablejs", false, [1,1,15,0], () => (__webpack_require__.e(1797).then(() => (() => (__webpack_require__(11797))))))),
	10632: () => (loadStrictVersion("default", "oidc-client", false, [1,1,11,5], () => (__webpack_require__.e(6958).then(() => (() => (__webpack_require__(66958))))))),
	32699: () => (loadStrictVersion("default", "web-vitals", false, [1,2,1,4], () => (__webpack_require__.e(6453).then(() => (() => (__webpack_require__(46453)))))))
};
var initialConsumes = [28217,7217];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"86": [
		50086
	],
	"252": [
		252
	],
	"406": [
		406
	],
	"418": [
		50418
	],
	"558": [
		1488,
		2674,
		3122,
		4220,
		5639,
		9400,
		11966,
		12162,
		13350,
		15980,
		22438,
		27214,
		27289,
		28459,
		28639,
		29167,
		30443,
		31926,
		35792,
		37112,
		39033,
		39686,
		39966,
		45007,
		53512,
		56249,
		58444,
		61016,
		66775,
		68374,
		76441,
		78385,
		80040,
		80918,
		87607,
		93024,
		93655,
		96052
	],
	"632": [
		10632
	],
	"1574": [
		41574
	],
	"2304": [
		12304
	],
	"2699": [
		32699
	],
	"2759": [
		15286,
		64860
	],
	"3524": [
		23524
	],
	"5640": [
		25640
	],
	"6733": [
		46733
	],
	"6990": [
		96990
	],
	"7090": [
		67090
	],
	"8006": [
		48006
	],
	"8017": [
		46738,
		47882
	],
	"8316": [
		68316
	],
	"8389": [
		11786,
		73766
	],
	"8634": [
		58634
	],
	"8660": [
		28660
	],
	"8792": [
		28217,
		7217
	],
	"8868": [
		58868
	],
	"9651": [
		39651
	],
	"9710": [
		89710
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}